import { Pipe } from '@angular/core';
import { isString, upperFirst } from '../utils/utils';
var UpperFirstPipe = (function () {
    function UpperFirstPipe() {
    }
    UpperFirstPipe.prototype.transform = function (input) {
        if (!isString(input)) {
            return input;
        }
        return upperFirst(input);
    };
    return UpperFirstPipe;
}());
export { UpperFirstPipe };
UpperFirstPipe.decorators = [
    { type: Pipe, args: [{
                name: 'upperfirst'
            },] },
];
/** @nocollapse */
UpperFirstPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=upperfirst.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/upperfirst.pipe.js
// module id = 295
// module chunks = 103